import React from 'react';
import { ReactComponent as ArrowIcon } from './arrow.svg';
import type { ArrowsControlProps, ArrowButtonProps } from '../interfaces';
import styled from 'styled-components';
import { ArrowDirection } from '../CubeButtonsController';

const ArrowsControl: React.FC<ArrowsControlProps> = ({ cubeButtonsController }) => {
  const [isArrowsShown, setArrowsVisibility] = React.useState(true);
  cubeButtonsController?.onButtonsVisibilityChanged((visibility) => setArrowsVisibility(visibility));

  const arrowDirections = [ArrowDirection.Up, ArrowDirection.Right, ArrowDirection.Down, ArrowDirection.Left];

  return (
    <>
      {isArrowsShown
        ? arrowDirections.map((direction) => {
            return (
              <ArrowButton
                onClick={(): void => cubeButtonsController?.changeDirection(direction)}
                key={direction}
                type={direction}
              />
            );
          })
        : null}
    </>
  );
};

let ArrowButton: React.FC<ArrowButtonProps> = (props) => {
  return <ArrowIcon onClick={props.onClick} className={props.className} type={props.type} />;
};

ArrowButton = styled(ArrowButton)<{ type: string }>`
  width: 2em;
  height: 2em;
  position: absolute;
  z-index: 1;
  cursor: pointer;

  @media only screen and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 2) {
    font-size: 0.7em;
  }

  ${(props): string => {
    switch (props.type) {
      case 'right':
        return `right: 0.5em;
                top: calc(50% - 1em);
                transform: rotate(180deg);`;
      case 'left':
        return `left: 0.5em;
                top: calc(50% - 1em);`;
      case 'up':
        return `top: 0.5em;
                left: calc(50% - 1em);
                transform: rotate(90deg);`;
      case 'down':
        return `bottom: 0.5em;
                left: calc(50% - 1em);
                transform: rotate(-90deg);`;
      default:
        return '';
    }
  }};

  .st0 {
    stroke: none;
  }
  :hover .st0 {
    fill: #00a3d8;
  }
  :hover .st1 {
    fill: #ffffff;
  }
`;

export default ArrowsControl;
